export const ACTION_FIELD_NAMES: string[] = [
  'pullObjectType',
  'pushObjectType',
  'pushAction',
  'parent',
  'database',
  'customerId',
  'invoiceId',
  'productId',
];

export const RESERVED_DATA_KEYS = new Set([
  'provider',
  'mode',
  'blobConfig',
  'flowTrigger',
  'label',
  'placement',
  'previewIndex',
  'canceled',
  'paused',
  'output',
]);

export const BLOB_RESERVED_KEYS = new Set([
  'blobConfig',
  'flowTrigger',
  'label',
  'placement',
  'previewIndex',
  'canceled',
  'paused',
  'output',
]);
